import { Button } from "../components/basics/Button";
import { ButtonType } from "../helpers/shared/buttonStyling";
import { useNavigate } from "react-router-dom";
import travelImg from "../assets/images/travel.svg";
import gpaImage from "../assets/images/gpa.svg";
import eventImg from "../assets/images/event.svg";
import fwbImg from "../assets/images/fwb.svg";
import fwmiImg from "../assets/icons/FWMI icon.svg";
import homeGuardImg from "../assets/icons/homeprotector.svg";
import Product from "./Product";
import { Region } from "../enums/shared/forms/Region";
import { isFwbEnabled, isFwmiEnabled, isFwmiRenewalEnabled, isHKHomeGuardEnabled, isHomeProtectorEnabled } from "../helpers/shared/featureFlags";
const awac_external_base_url = () => process.env.REACT_APP_AWAC_EXTERNAL_BASE_URL;

interface IProps {
  t: any;
  region: string;
}
interface ProductsForHKProps {
  t: any;
  eventLink: JSX.Element;
  hkHomeGuardLink: JSX.Element;
  isHKHomeGuardActive: boolean;
}

interface ProductsForSGProps {
  t: any;
  eventLink: JSX.Element;
  travelLink: JSX.Element;
  fwbLink: JSX.Element;
  homeprotectorLink: JSX.Element;
  fwmiLink: JSX.Element;
  isFwbActive: boolean;
  isFwmiActive: boolean;
  isFwmiRenewalActive: boolean;
  isHomeProtectorActive: boolean;
}

interface ProductsForAUProps {
  t: any;
  eventLink: JSX.Element;
  groupPersonalAccidentLink: JSX.Element;
}
const retrieveLink: Record<string, string> = {
  [Region.SG]: "/event_public_liability/retrieveList",
  [Region.HK]: "/event_public_liability/hk/retrieveList",
  [Region.AU]: "/au/group_travel/retrieve-list",
};
const quoteLink: Record<string, string> = {
  [Region.SG]: "/event_public_liability",
  [Region.HK]: "/event_public_liability/hk",
  [Region.AU]: "/au/group_travel/form/basic-details",
};

const ProductsForSG: React.VFC<ProductsForSGProps> = ({
  t,
  eventLink,
  travelLink,
  fwbLink,
  fwmiLink,
  isFwbActive,
  isFwmiActive,
  isFwmiRenewalActive,
  isHomeProtectorActive,
  homeprotectorLink,
}) => (
  <div className="mb-20 md:w-full">
    <div className="md:flex md:flex-row">
      <div className="md:w-3/6 md:pt-10">
        <Product
          alt={"travel logo"}
          type="travel"
          img={travelImg}
          text={t("header.button.travelProtector")}
          topLinks={travelLink}
          download={false}
          className="md:h-60"
        />
      </div>
      <div className="md:w-3/6 md:pt-10 md:pl-8 pt-4">
        <Product img={eventImg} alt="event logo" text={t("header.button.eventPublic")} topLinks={eventLink} download={false} className="md:h-60" />
      </div>
    </div>
    {isHomeProtectorActive && (
      <div className="md:flex md:flex-row md:mt-8 my-4 md:mb-16">
        <div className="md:w-3/6">
          <Product
            img={homeGuardImg}
            alt="homeprotector logo"
            text={t("header.button.homeprotectorTitle")}
            topLinks={homeprotectorLink}
            download={false}
            className="md:h-60"
          />
        </div>
      </div>
    )}
    <div>
      <p className={`${isHomeProtectorActive ? "md:text-2xl font-bold font-sans" : "md:text-2xl font-bold font-sans md:mt-8 mt-4"}`}>
        {t("header.button.eligibleAgentsOnly")}
      </p>
    </div>
    <div className="md:flex md:flex-row pt-4">
      <div className="md:w-3/6">
        <Product
          img={fwbImg}
          alt={"fwb logo"}
          text={t("header.button.fwbTitle")}
          topLinks={fwbLink}
          download={false}
          isActive={isFwbActive}
          className={`${isFwmiRenewalActive ? "md:h-72" : "md:h-60"}`}
        />
      </div>
      <div className="md:w-3/6 md:pl-8 md:pt-0 pt-4">
        <Product
          img={fwmiImg}
          alt="fwmi logo"
          text={t("header.button.fwmiTitle")}
          topLinks={fwmiLink}
          download={false}
          isActive={isFwmiActive}
          className={`${isFwmiRenewalActive ? "md:h-72" : "md:h-60"}`}
        />
      </div>
    </div>
  </div>
);

const ProductsForHK: React.VFC<ProductsForHKProps> = ({ t, eventLink, hkHomeGuardLink, isHKHomeGuardActive }) => (
  <div className="md:flex md:flex-row mb-20 md:w-full">
    {/* Product for HK */}
    <div className="md:w-3/6 md:pt-10">
      <Product img={eventImg} alt={"event logo"} text={t("header.button.eventPublic")} topLinks={eventLink} download={false} className="md:h-60" />
    </div>
    {isHKHomeGuardActive && (
      <div className="md:w-3/6 md:pt-10 md:pl-8 pt-4">
        <Product
          alt={"HomeGuard logo"}
          img={homeGuardImg}
          text={t("header.button.hkHomeGuardTitle")}
          topLinks={hkHomeGuardLink}
          download={false}
          isActive={isHKHomeGuardActive}
          className="md:h-60"
        />
      </div>
    )}
  </div>
);

const ProductsForAU: React.VFC<ProductsForAUProps> = ({ t, eventLink, groupPersonalAccidentLink }) => (
  //Product for AU
  <div className="md:flex md:flex-row mb-20 md:w-full">
    <div className="md:w-3/6 md:pt-10">
      <Product img={travelImg} alt={"travel logo"} text={t("header.button.groupTravel")} topLinks={eventLink} download={false} className="md:h-60" />
    </div>

    <div className="md:w-3/6 md:pt-10 md:pl-8 pt-4">
      <Product
        alt={"group personal accident logo"}
        img={gpaImage}
        text={t("header.button.groupPersonalAccident")}
        topLinks={groupPersonalAccidentLink}
        download={false}
        className="md:h-60"
      />
    </div>
  </div>
);

export const Products = ({ region, t }: IProps) => {
  const navigate = useNavigate();
  const isFwbActive = isFwbEnabled();
  const isFwmiActive = isFwmiEnabled();
  const isFwmiRenewalActive = isFwmiRenewalEnabled();
  const isHomeProtectorActive = isHomeProtectorEnabled();
  const isHKHomeGuardActive = isHKHomeGuardEnabled();

  const findPolicy = (
    <Button className="max-h-11 md:max-w-[203px] md:px-4" onClick={() => navigate("/travel/retrieveList")} type={ButtonType.SECONDARY}>
      {t("header.button.findPolicy")}
    </Button>
  );

  const travelLink = (
    <>
      <Button
        className="max-h-11 md:max-w-[203px] md:px-4"
        onClick={() => {
          navigate("/travel/details");
        }}
        type={ButtonType.PRIMARY}
      >
        {t("header.button.buyNow")}
      </Button>
      {findPolicy}
    </>
  );
  const eventLink = (
    <>
      <Button
        className="max-h-11 md:max-w-[203px] md:px-4"
        onClick={() => {
          navigate(quoteLink[region]);
        }}
        type={ButtonType.PRIMARY}
      >
        {t("header.button.getQuote")}
      </Button>
      <Button className="max-h-11 md:max-w-[203px] md:px-4" type={ButtonType.SECONDARY} onClick={() => navigate(retrieveLink[region])}>
        {t("header.button.retrieveQuote")}
      </Button>
    </>
  );
  const hkHomeGuardLink = (
    <>
      <Button
        className="max-h-11 md:max-w-[203px] md:px-4"
        onClick={() => {
          window.open(awac_external_base_url() + "/hk/homeguard/quote/create", "_self");
        }}
        type={ButtonType.PRIMARY}
      >
        {t("header.button.buyNow")}
      </Button>
      <Button
        className="max-h-11 md:max-w-[203px] md:px-4"
        type={ButtonType.SECONDARY}
        onClick={() => {
          window.open(awac_external_base_url() + "/hk/homeguard/quote/list", "_self");
        }}
      >
        {t("header.button.findPolicy")}
      </Button>
    </>
  );

  const fwbLink = (
    <div className="flex flex-col gap-4 md:gap-8">
      <div className="flex flex-col gap-4 md:flex-row md:gap-4">
        <Button
          className="max-h-11 md:max-w-[203px] md:px-4"
          onClick={() => {
            window.open(awac_external_base_url() + "/fwb/quote", "_self");
          }}
          type={ButtonType.PRIMARY}
        >
          {t("header.button.buyNow")}
        </Button>
        <Button
          className="max-h-11 md:max-w-[203px] md:px-4"
          type={ButtonType.SECONDARY}
          onClick={() => {
            window.open(awac_external_base_url() + "/fwb/quote/list", "_self");
          }}
        >
          {t("header.button.retrieveQuote")}
        </Button>
      </div>

      <div className="flex flex-col gap-4 md:flex-row md:gap-4">
        <Button
          className="max-h-11 md:max-w-[203px] md:px-4"
          type={ButtonType.SECONDARY}
          onClick={() => {
            window.open(awac_external_base_url() + "/fwb/worker/list", "_self");
          }}
        >
          {t("header.button.workerEnquiry")}
        </Button>
      </div>
    </div>
  );

  const homeprotectorLink = (
    <>
      <Button
        className="max-h-11 md:max-w-[203px] md:px-4"
        onClick={() => {
          window.open(awac_external_base_url() + "/homeprotector/quote/create", "_self");
        }}
        type={ButtonType.PRIMARY}
      >
        {t("header.button.buyNow")}
      </Button>
      <Button
        className="max-h-11 md:max-w-[203px] md:px-4"
        onClick={() => {
          window.open(awac_external_base_url() + "/homeprotector/quote/list", "_self");
        }}
        type={ButtonType.SECONDARY}
      >
        {t("header.button.retrieveQuote")}
      </Button>
    </>
  );

  const fwmiLink = (
    <div className="flex flex-col gap-4 md:gap-8">
      <div className="flex flex-col gap-4 md:flex-row md:gap-4">
        <Button
          type={ButtonType.PRIMARY}
          className="max-h-11 md:max-w-[203px] md:px-4"
          onClick={() => {
            window.open(awac_external_base_url() + "/fwmi/quote/create", "_self");
          }}
        >
          {t("header.button.buyNow")}
        </Button>
        <Button
          className="max-h-11 md:max-w-[203px] md:px-4"
          type={ButtonType.SECONDARY}
          onClick={() => {
            window.open(awac_external_base_url() + "/fwmi/quote/list", "_self");
          }}
        >
          {t("header.button.fwmiRetrieveQuote")}
        </Button>
      </div>
      {isFwmiRenewalActive && (
        <div className="flex flex-col gap-4 md:flex-row md:gap-4">
          {/* <Button
            className="max-h-11 md:max-w-[203px] md:px-4"
            type={ButtonType.SECONDARY}
            onClick={() => {
              window.open(awac_external_base_url() + "/fwmi/policy/list", "_self");
            }}
          >
            {t("header.button.findPolicy")}
          </Button> */}
          <Button
            className="max-h-11 md:max-w-[203px] md:px-4"
            type={ButtonType.SECONDARY}
            onClick={() => {
              window.open(awac_external_base_url() + "/fwmi/renewal/list", "_self");
            }}
          >
            {t("header.button.renewal")}
          </Button>
        </div>
      )}
    </div>
  );

  const groupPersonalAccidentLink = (
    <>
      <Button
        className="max-h-11 md:max-w-[203px] md:px-4"
        onClick={() => {
          navigate("/au/group_personal_accident/form/basic-details");
        }}
        type={ButtonType.PRIMARY}
      >
        {t("header.button.getQuote")}
      </Button>
      <Button
        className="max-h-11 md:max-w-[203px] md:px-4"
        type={ButtonType.SECONDARY}
        onClick={() => navigate("/au/group_personal_accident/retrieve-list")}
      >
        {t("header.button.retrieveQuote")}
      </Button>
    </>
  );

  let productsToDisplay = null;
  if (region === Region.SG)
    productsToDisplay = (
      <ProductsForSG
        t={t}
        eventLink={eventLink}
        travelLink={travelLink}
        fwbLink={fwbLink}
        homeprotectorLink={homeprotectorLink}
        fwmiLink={fwmiLink}
        isFwbActive={isFwbActive}
        isFwmiActive={isFwmiActive}
        isFwmiRenewalActive={isFwmiRenewalActive}
        isHomeProtectorActive={isHomeProtectorActive}
      />
    );
  if (region === Region.HK)
    productsToDisplay = <ProductsForHK t={t} eventLink={eventLink} hkHomeGuardLink={hkHomeGuardLink} isHKHomeGuardActive={isHKHomeGuardActive} />;
  if (region === Region.AU) productsToDisplay = <ProductsForAU t={t} eventLink={eventLink} groupPersonalAccidentLink={groupPersonalAccidentLink} />;

  return productsToDisplay;
};
